
export const blogPosts = [
  {
    id: "celebrating-courage-everyday-women",
    title:
      "Drishtikon Himmatwaali Mission: Celebrating the Courage of Everyday Women",
    excerpt:
      "Recognizing the strength, resilience, and spirit of India's true Himmatwaalis — domestic workers, caregivers, and unsung women heroes.",
    publishedDate: "7 July 2026",
    image: "https://drishtikonhimmatwaalimission.org/blog/image1.jpeg",
    imageAlt:
      "Dr. Sushma Sengupta, founder inspiration of Drishtikon Himmatwaali Mission",
    href: "https://drishtikonhimmatwaalimission.org/blog/Drishtikon-Himmatwaali-Mission-Celebrating-the-Courage-of-Everyday-Women.html",
  },
  {
    id: "how-drishtikon-himmatwaali-mission-is-impacting-the-lives",
    title:
      "How Drishtikon Himmatwaali Mission is Impacting the Lives of Himmatwaalis",
    excerpt:
      "Discover how the Drishtikon Himmatwaali Mission is creating a lasting impact by recognizing, empowering, and building self-confidence in courageous everyday women across India." ,
    publishedDate: "23 August 2026",
    image: "https://drishtikonhimmatwaalimission.org/blog/image2.jpeg",
    imageAlt: "Impact hero image for Drishtikon Himmatwaali Mission blog",
    href: "https://drishtikonhimmatwaalimission.org/blog/How%20Drishtikon%20Himmatwaali%20Mission%20is%20Impacting%20the%20Lives%20of%20Himmatwaalis.html"
  },
];
